<script>
  // export var settings;
  // export var recs;
  // export var openRec;

  import {
    Button,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Card,
    Col,
    Table
  } from "sveltestrap";
  import { Form, FormGroup, FormText, Label } from "sveltestrap";

  import { from } from './from'
  import { global } from './state.js'
  import { openRec } from './recs.js'

  let availableRecs = [];

  if (!global.noauth) {
    console.log("fetching recs", {global})
    from("/recs", {}).then(r=>r.json()).then(json => {
      // console.log("/recs", json);
      availableRecs = json.recs ? json.recs : [];
    })
  }

  function removeFromLocalState(id) {
    availableRecs = [...availableRecs].filter(r=>r.id != id)
  }

  function removeRec(id) {
    if (global.noauth) {
      removeFromLocalState(id);
      return;
    }
    from("/recs", {method:"DELETE", body:JSON.stringify({id})}).then(r=>r.json()).then(json => {
      removeFromLocalState(id)
    }).catch(ex => {
      console.log("error while removing rec", id, ex);
      // use an event to bubble up components to error / msg handler?
    })
  }
</script>

Current: 
{#if availableRecs.length == 0}
  None
{:else}
  <Table class="table-sm">
    <tr>
      <th>Name</th>
      <th>Source A</th>
      <th>Source B</th>
      <th></th>
    </tr>
  {#each availableRecs as rec}
  <tr>
    <td title="{rec.id}">{rec.name}</td>
    <td>{rec.a ? rec.a.name : JSON.stringify(rec)}</td>
    <td>{rec.b ? rec.b.name : JSON.stringify(rec)}</td>
    <td>
      <a href="javascript:void(0)" on:click={()=>openRec(rec.id)}>Open</a>
      <a href="javascript:void(0)" on:click={()=>removeRec(rec.id)}>Remove</a>
    </td>
  </tr>
  {/each}
  </Table>
{/if}